<div class="product-card" (click)="onClick()">
  <div class="product-info">
    <span class="name">{{ product.name }}</span>
    <!-- <span class="price">{{ priceDisplay }}</span> -->
  </div>
  <ion-icon name="chevron-forward-outline" class="chevron" />
</div>
